import React from 'react';
import { NavLink } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import moment from 'moment-timezone';
import { toDisplayDateTimeString } from '../../../helpers/moment-ex';
import { SearchTextBox } from '../../widgets/Inputs';
import '../../../../assets/scss/checkbox.scss';
import '../../../../assets/scss/left-side-menu.scss';

export class SubNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseSideBar: false
    };
    this.collapseSideBar = this.collapseSideBar.bind(this);
  }

  collapseSideBar() {
    this.setState({ collapseSideBar: !this.state.collapseSideBar });
  }

  render() {
    // return (<div className={`animate left-sidebar-subnav ${this.state.collapseSideBar ? "left-sidebar-submenu-collapse" : "left-sidebar-submenu animate__slideInLeft"} ${this.props.className || ""}`}>
    return (<div className={`animate left-sidebar-subnav ${this.state.collapseSideBar ? "left-sidebar-submenu-collapse" : "left-sidebar-submenu"} ${this.props.className || ""}`}>
      {this.state.collapseSideBar
        ? <ToggleButton onClick={this.collapseSideBar} iconClassName="fa fa-chevron-right" />
        : <div>
          <ToggleButton onClick={this.collapseSideBar} iconClassName="fa fa-chevron-left" />
          {this.props.children}
        </div>}
    </div>);
  }
}

export const ToggleButton = ({ onClick, iconClassName }) =>
(<div className="btn-toggle" onClick={onClick}>
  <i className={iconClassName}></i>
</div>);

export const SubNavHeader = ({ children }) =>
  (<h6 className="sm-title pb-0">{children}</h6>);

export const SubNavSubheader = ({ children }) =>
  (<h6 className="sm-title mt-2 pt-0 pb-3">{children}</h6>);

export const SubNavAddButton = ({ to, onClick, title }) => {
  if (onClick) {
    return (<button className="m-0 p-0 hand-symbol btn-add" onClick={onClick}>
      <i className="fa fa-plus-circle" title={title || 'Add'}></i>
    </button>)
  }
  else {
    return (<NavLink className="m-0 p-0 hand-symbol btn-add" to={to}>
      <i className="fa fa-plus-circle"></i>
    </NavLink>);
  }
}

/* export const SubNavSearchBox = React.forwardRef(({ placeholder, onChange, value }, ref) =>
  (<div className="input-group search-box">
    <input
      ref={ref}
      className="form-control search-input py-2 border-right-0 border"
      type="input"
      value={value}
      autoComplete="off"
      placeholder={placeholder}
      onChange={onChange}
    />
    <span className="input-group-append hand-symbol">
      <div className="input-group-text">
        <i className="fa fa-search" />
      </div>
    </span>
  </div>)); */

export const SubNavSearchBox = React.forwardRef((props, ref) =>
  <SearchTextBox {...{ ...props, className: "search-box", ref }} />);

export const SubNavList = ({ children }) => (<ul>{children}</ul>);

export const SubNavNotFound = ({ children }) =>
(<div className="list-no-record">
  {children || "No records found"}
</div>);

export const SubNavLoading = ({ children }) =>
(<div className="list-loading">
  {children || "Loading..."}
</div>);

export const SubNavItem = ({ children, selected, className }) => {
  const activeClassName = selected ? 'selected' : '';
  return (<li className={`list-item ${className || ''} ${activeClassName || ''}`}>
    {children}
  </li>);
}

export const SubNavCard = ({ className, children, onClick }) =>
  (<Col className={`p-0 m-0 pt-1 pb-1 ${className ? className : ""}`} onClick={onClick}>{children}</Col>);

export const SubNavLink = ({ to, children, bullet, onClick }) =>
  (<NavLink className={`list-text ${bullet ? "bullet" : ""}`} {...{ to, onClick }}>{children}</NavLink>);

export const SubNavButtonGroup = ({ children }) =>
  (<span className="float-right btn-action-group">{children}</span>);

export const SubNavName = ({ className, bullet, children }) =>
  (<span className={`mb-0 list-text ${bullet ? "bullet" : ""} ${className || ""}`}>{children}</span>);

export const SubNavDisplay1 = ({ children }) =>
  (<label className="list-sub-text display-1 mb-0">{children}</label>);

export const SubNavDisplay2 = ({ children }) =>
  (<label className="list-sub-text display-2 mb-0">{children}</label>);

export const SubNavDisplay3 = ({ children }) =>
  (<label className="list-sub-text display-3 mb-0">{children}</label>);

export const SubNavDateRange = ({ className, start, end, alive, isCrewworkPlan = false }) =>
(<label className={`list-sub-text display-date-range ${className || ""}`}>
  <span><i className="fa fa-calendar mr-1" /></span>
  {toDisplayDateTimeString(start, (moment.utc(start).year() === moment.utc().year()))}
  {(alive || end !== null) && <i className="fa fa-long-arrow-right i-arrow" aria-hidden="true"></i>}
  {isCrewworkPlan ? end !== null ? toDisplayDateTimeString(end, (moment.utc(end).year() === moment.utc().year())) : ""
    : alive ? "Now" : toDisplayDateTimeString(end, (moment.utc(end).year() === moment.utc().year()))}
</label>);

export const SubNavFlagButton = ({ className, active, onClick }) =>
(<i className={`icon ${active ? "icon-unpin" : "icon-pin"} pr-2 ${className ? className : ''}`}
  title={`${active ? 'Unpin' : "Pin"}`} onClick={onClick}></i>);

export const SubNavEditButton = ({ title, onClick, children }) =>
(<i className="fa fa-pencil pr-2 fa-action-btn" title={title || 'Edit'}
  onClick={onClick}>{children}</i>);

export const SubNavDeleteButton = ({ title, onClick, children, className }) =>
(<i className={`fa fa-trash fa-action-btn ${className ? className : ''}`} title={title || 'Delete'}
  onClick={onClick}>{children}</i>);

export const SubNavActiveButton = ({ title, onClick, children, className }) =>
(<i className={`fa fa-undo pr-2 fa-action-btn ${className ? className : ''}`} title={title || 'Restore'}
  onClick={onClick}>{children}</i>);

export const SubNavCheckbox = ({ checked, onChange, className }) =>
(<div className="checkmark-container">
  <input type="checkbox" checked={checked} onChange={onChange} />
  <span className={`checkmark ${className ? className : ''}`}></span>
</div>);

export const SubNavPipe = () => <div className="symbol-pipe" />;

export const SubNavDivider = ({ name, className }) => <div className={`${className ? className : 'divider'}`}><span>{name}</span></div>;

export const SubNavImportButton = ({ to, onClick, title }) => {
  return (<button className="m-0 p-0 hand-symbol btn-add" onClick={onClick}>
    <i className="fa fa-upload ml-3" title={title || 'Import'}></i>
  </button>)
}

export const SubNavSaveAllButton = ({ to, onClick, title }) => {
  return (<button className="m-0 p-0 hand-symbol btn-add" onClick={onClick}>
    <i className="fa fa-floppy-o ml-3" title="save"></i>
  </button>)
}

export const SubNavQRButton = ({ title, onClick, children }) =>
(<i className="fa fa-qrcode m-0 p-0 hand-symbol" title={title || 'Generate QR'}
  onClick={onClick}>{children}</i>);

SubNav.Header = SubNavHeader;
SubNav.Subheader = SubNavSubheader;
SubNav.SearchBox = SubNavSearchBox;
SubNav.List = SubNavList;
SubNav.Item = SubNavItem;
SubNav.Link = SubNavLink;
SubNav.ButtonGroup = SubNavButtonGroup;
SubNav.AddButton = SubNavAddButton;
SubNav.FlagButton = SubNavFlagButton;
SubNav.EditButton = SubNavEditButton;
SubNav.DeleteButton = SubNavDeleteButton;
SubNav.ActivateButton = SubNavActiveButton;
SubNav.NotFound = SubNavNotFound;
SubNav.Loading = SubNavLoading;
SubNav.Checkbox = SubNavCheckbox;
SubNav.Display1 = SubNavDisplay1;
SubNav.Display2 = SubNavDisplay2;
SubNav.Display3 = SubNavDisplay3;
SubNav.Name = SubNavName;
SubNav.DateRange = SubNavDateRange;
SubNav.Card = SubNavCard;
SubNav.Pipe = SubNavPipe;
SubNav.Divider = SubNavDivider;
SubNav.ImportButton = SubNavImportButton;
SubNav.SaveAllButton = SubNavSaveAllButton;
SubNav.QRButton = SubNavQRButton;
